import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态 · 平台快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            平台内容更新、功能升级和社区建设的最新消息，随时了解91影视的最新变化
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, index) => (
              <div key={item.id} className={`relative pb-8 ${index === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[29px] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <span className="text-xs font-medium text-primary-600 whitespace-nowrap bg-primary-50 px-2 py-0.5 rounded self-start">
                    {item.date}
                  </span>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-800 font-medium leading-relaxed">
                      {item.title}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}